import { gql } from '@apollo/client';

const COMPONENT_LIST_SET = gql`
    query ComponentListSet( $componentListSetId: UUID! ) {
        componentListSet( componentListSetID: $componentListSetId ) {
            node {
                componentListSetId
                type
                name
                description
                isPublished
                componentLists
                createdAt
                updatedAt

                segmentIds
                brandIds
                productIds
                localeIds
                companyRelationshipIds
                employeeLocaleIds
                learningProfileIds
            }
        }
    }`
;

export default COMPONENT_LIST_SET;
